export const containerWidth = 1140
export const containerPadding = 6
export const containerMobilePadding = 14
export const headerHeight = 66
export const headerMargin = 30
export const sectionMargin = 130
export const sectionMobileMargin = 60
export const blockTextHeight = 420
export const sidebarWidth = 250
export const contentWidth = 860
